<app-versatile-list>
    <app-versatile-list-header [isLoading]="isLoading">
        <ng-container *ngIf="!isLoading; else headerPlaceholder">
            <div class="header-content">
                <app-scroll-list-item
                    [title]="resolvedHeaderTitle"
                    [subtitle]="resolvedHeaderSubtitle"
                    [selected]="false"
                    [highlighted]="false"
                    [leftIcon]="'fa-folder'">
                </app-scroll-list-item>
                <div class="header-actions">
                    <ng-content select="[registryHeaderActions]"></ng-content>
                </div>
            </div>
        </ng-container>
        <ng-template #headerPlaceholder>
            <div class="header-placeholder">
                <div class="title">{{ resolvedHeaderTitle }}</div>
                <div class="subtitle">{{ resolvedHeaderSubtitle }}</div>
            </div>
        </ng-template>
    </app-versatile-list-header>

    <app-versatile-list-body
        [items]="internalItems"
        [total]="internalItems?.length || 0"
        [useVirtualScroll]="false"
        [isLoading]="isLoading">
        <ng-template versatileListItem let-item let-index="index">
            <app-sample-board-registry-item
                class="list__item"
                [item]="item"
                [index]="index"
                [itemType]="itemType"
                (openRegistry)="onOpenRegistry($event)">
            </app-sample-board-registry-item>
        </ng-template>

        <ng-container versatileListEmpty>
            <app-empty-state
                icon="fa-square-o"
                [text]="resolvedEmptyText">
            </app-empty-state>
        </ng-container>
    </app-versatile-list-body>
</app-versatile-list>
